import { useTranslation } from "react-i18next"

import { Button } from "@/components/Button"
import { AppleShareIcon } from "@/components/icons"
import { Modal } from "@/components/Modal"

interface InstallModalProps {
  closeModal: () => void
}

export const PWAInstallModal = ({ closeModal }: InstallModalProps) => {
  const { t } = useTranslation()
  return (
    <Modal shouldShow>
      <div className="text-center">
        <h5 className="pb-lg display-sm-regular">
          {t("pwa.installReactiveTrader")}
        </h5>
        <p className="text-sm-regular" color="Colors/Text/text-secondary">
          {t("pwa.installManually.stepA")}
        </p>
        <p className="pb-md text-sm-regular text-secondary">
          {t("pwa.installManually.stepB")}{" "}
          <div className="mb-[4px] inline-flex align-middle">
            <AppleShareIcon />
          </div>{" "}
          {t("pwa.installManually.stepC")}
        </p>
        <Button variant="outline" size="lg" onClick={closeModal}>
          {t("pwa.close")}
        </Button>
      </div>
    </Modal>
  )
}
